import { useToggle } from "react-use"

import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/shadcn-utils"

interface VisibilityToggleProps {
  onVisibilityChange?: (isVisible: boolean) => void
  className?: string
  ariaLabelShow?: string
  ariaLabelHide?: string
}

export function VisibilityToggleButton({
  onVisibilityChange,
  className,
  ariaLabelShow = "Show",
  ariaLabelHide = "Hide",
}: VisibilityToggleProps) {
  const [isVisible, setIsVisible] = useToggle(false)

  function handleToggle() {
    setIsVisible()
    onVisibilityChange?.(!isVisible)
  }

  return (
    <button
      onClick={handleToggle}
      className={cn(
        "tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-h-full tw-px-3 tw-flex tw-items-center tw-justify-center tw-text-gray-500 hover:tw-text-gray-700 focus:tw-outline-none",
        className,
      )}
      tabIndex={-1}
      aria-label={isVisible ? ariaLabelHide : ariaLabelShow}
    >
      {isVisible ? (
        <EyeOff className="tw-h-5 tw-w-5" />
      ) : (
        <Eye className="tw-h-5 tw-w-5" />
      )}
    </button>
  )
}
